import "./style.scss";
import SidebarCollapse from "../../../app/SidebarCollapse";
import { useAppDispatch, useAppSelector } from "../../../../store/store";
import { setCurrentPopup, setIconState } from "../../../../store/slices/popupSlice";
import { EditableProps } from "../../editableProps";
import { getSelectedNode } from "@builder/store/slices/BuilderSlice/builderSelectors";
import { updateNodeProperty } from "@builder/store/slices/BuilderSlice/builderSlice";
import SelectImage from "@builder/components/general/SelectImage";
import { getValueAtPath } from "@builder/components/editable/helpers";
import { useEffect } from "react";

const EditIcon: React.FC<EditableProps> = ({ parent, path, title, condition, noRemoveImage, customLabel, noWrapper }: EditableProps) => {
    const dispatch = useAppDispatch();
    const node = useAppSelector(getSelectedNode) as any;
    const src = path ? getValueAtPath(node, [...path, "src"]) : node?.icon?.src;
    const activeNode = useAppSelector(state => state.builder.activeNode);

    useEffect(() => {
        dispatch(setIconState(null));
    }, []);

    const iconCallback = () => {
        dispatch(setIconState(path ? path : null));
        dispatch(setCurrentPopup("icons"));
    };

    const removeIconCallback = () => {
        dispatch(updateNodeProperty({ propertyPath: path ? path : ["icon"], value: "", remove: true }));
    };

    if (condition && (!node || !condition(node, activeNode))) return null;

    if (noWrapper) {
        return (
            <SelectImage
                type="icon"
                callback={iconCallback}
                removeCallback={noRemoveImage ? undefined : removeIconCallback}
                img={src}
                label={customLabel ? customLabel : "Select Icon"}
            />
        );
    } else {
        return (
            <SidebarCollapse title={title || "Icon"} parent={parent}>
                <SelectImage
                    type="icon"
                    callback={iconCallback}
                    removeCallback={noRemoveImage ? undefined : removeIconCallback}
                    img={src}
                    label={customLabel ? customLabel : "Select Icon"}
                />
            </SidebarCollapse>
        );
    }
};

export default EditIcon;
